<template>
<div class="background-style">
  <div class="content">
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image.syimgurl" />
      </van-swipe-item>
    </van-swipe>
    <Heador />
    <van-notice-bar left-icon="volume-o" text="请您第一站先至我司停车场扫码打印入门证" />
    <van-notice-bar left-icon="volume-o" text="无押运员的普货车辆请到押运员界面录入司机信息" />
    <Panels />
  </div>
</div>
</template>

<script>
import {
  Toast,
} from 'vant';

import api from "@/fetch/api"
import Heador from "./headerTpl.vue"
import Panels from "./panelTpl.vue"
export default {
  components: {
    Heador,
    Panels,
  },
  created() {
    document.title = "首页";
    var that = this;
    that.getSwipeList();
    var mobile = that.$store.state.wx_info.mobile ? that.$store.state.wx_info.mobile : "";
    var openid = that.$store.state.wx_info.openid ? that.$store.state.wx_info.openid : "";
    that.openid = openid;
    if (mobile == '') {
      that.$router.push({
        name: 'userinfo'
      })
    }
  },
  methods: {
    getSwipeList() {
      var that = this;
      api.getSwipeList().then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.$data.images = resData.data;
        } else {
          that.$data.images = [{
            syimgurl: 'http://hqyy.tzpdg.top/image/shouye/shouye1.png'
          }];
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },

  },
  data() {
    return {
      navTitle: "首页",
      leftText: "",
      rightText: "",
      leftArrow: false,
      vehicleState: '01',
      images: [],
      openid:"",
    }
  }
}
</script>

<style lang="scss" scoped>
.background-style {
    background: #fff;
}

.background-margin {
    margin: 0 0.28rem;
    //background: red;

}
.content {
    .van-swipe-item {
        img {
            width: 100%;
            height: 9.75rem;
            object-fit: cover;
        }
    }
}
</style>
